export default __webpack_public_path__ + "static/media/email info.f20f734b.svg";